export const replacementLabels = {
  xpts_fpl: 'Exp. FPL Points'
};
